/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import { userHasRole } from '@/util/RoleUtils';
import GetAllRegionGroups from '@/services/GetAllRegionGroups';

import GeneralView from '../views/GeneralView';
import GetAdminConfiguration from '../services/GetAdminConfiguration';
import GetKOInformation from '../services/GetKOInformation';
import GetAllRegions from '../../common/services/GetAllRegions';

export default async function loadGeneralView() {
  if (!userHasRole('Admin')) {
    showErrorView({ message: 'Unauthorized' });
    return;
  }

  try {
    const [configurations, koInformation, regions, regionGroups] = await Promise.all([
      GetAdminConfiguration(),
      GetKOInformation(),
      GetAllRegions(),
      GetAllRegionGroups()
    ]);

    return new GeneralView({
      model: new Backbone.Model({ configurations, koInformation, regions: regions.filter((region) => region.isSpecialty === 'false'), regionGroups })
    });
  } catch (err) {
    showErrorView(err);
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred'
      })
    })
  );
}
